import React, { useRef, useState, useCallback, useMemo, forwardRef, useImperativeHandle } from 'react';
import { cloneDeep } from 'lodash';
import { Dropdown, Menu } from 'antd';
import classnames from 'classnames';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { iconMap, treeDFS, getTreeNodeById, folderNameValidate, folderId2String, folderId2Number, mailConfigStateIsMerge, folderAddOperCheck, validateFolderTreeCount, isMailFolderId, folderIdIsContact, folderCanShowUnread, folderIdIsContactGroup, folderIdIsAllFolderSubAccount, parseAllFolderSubAccount, parseFidFromAllFid, } from '../../util';
import { FLOLDER } from '../../common/constant';
import { validateFolderHasRepeatNamePrue, getSystemTopFolder } from '../../state/customize';
import useCreateCallbackForEvent from '../../hooks/useCreateCallbackForEvent';
import useStateRef from '../../hooks/useStateRef';
import './tree.scss';
import EditTree from './EditTree';
import { getIn18Text } from 'api';
import HollowOutGuide from '@web-common/components/UI/HollowOutGuideNew/hollowOutGuide';
const wmReplyGuideKey = 'WM_REPLY_GUIDE_KEY';
const defaultMailBoxModel = {
    children: [],
    mailBoxId: 0,
    childrenCount: 0,
    _account: '',
    entry: {
        id: '',
        mailBoxName: '',
        mailBoxCurrentUnread: 0,
        mailBoxUnread: 0,
        mailBoxTotal: 0,
        mailBoxParent: 0,
        mailBoxId: 0,
        pid: 0,
        threadMailBoxCurrentUnread: 0,
        threadMailBoxTotal: 0,
        threadMailBoxUnread: 0,
        mailBoxType: 'customer',
        sort: 0,
        _deep: 1,
    },
};
const defaultValidateFolderChanged = (treeList, node) => {
    if (node && node.entry) {
        const { mailBoxName, pid = 0 } = node.entry;
        const parentNode = getTreeNodeById(treeList, pid);
        let brotherNodes = [];
        if (pid === 0) {
            brotherNodes = getSystemTopFolder(treeList);
        }
        if (pid !== 0 && parentNode) {
            brotherNodes = parentNode.children || [];
        }
        if (!folderNameValidate(mailBoxName)) {
            return false;
        }
        if (validateFolderHasRepeatNamePrue(brotherNodes, node)) {
            Message.warn({
                content: getIn18Text('YICUNZAITONGMING'),
                key: mailBoxName,
            });
            return false;
        }
    }
    return true;
};
const defaultOuterAllowDrop = () => true;
const getEmptyMailBoxModel = () => cloneDeep(defaultMailBoxModel);
const folderCanShowOperBtn = (node) => {
    const { mailBoxId } = node === null || node === void 0 ? void 0 : node.entry;
    return mailBoxId != null;
};
export const getMailFolderIcon = (data) => {
    const id = data.mailBoxId;
    const expire = data.expire;
    let resIcon = React.createElement(ReadListIcons.FolderSvg, null);
    if (isMailFolderId(id) && iconMap.get(id)) {
        resIcon = iconMap.get(id);
    }
    if (folderIdIsAllFolderSubAccount(id)) {
        const fid = parseAllFolderSubAccount(id);
        resIcon = iconMap.get(fid);
    }
    if (folderIdIsContact(id)) {
        if (folderIdIsContactGroup(id)) {
            resIcon = React.createElement(ReadListIcons.StartGroupSvg, null);
        }
        else {
            resIcon = iconMap.get(FLOLDER.STAR);
        }
    }
    if (expire) {
        return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
            resIcon,
            React.createElement("div", { style: { marginLeft: '-4px', marginBottom: '-3px' } },
                React.createElement("svg", { width: "4", height: "13", viewBox: "0 0 4 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("g", { "clip-path": "url(#clip0_1993_27673)" },
                        React.createElement("path", { d: "M0.583333 13L0.583333 13.75L1.33333 13.75L4 13.75L4.75 13.75L4.75 13L4.75 10.4L4.75 9.65002L4 9.65002L1.33333 9.65002L0.583333 9.65002L0.583333 10.4L0.583333 13Z", fill: "#F74F4F", "stroke-width": "1.5" }),
                        React.createElement("path", { d: "M0.583333 9.09999L0.583333 9.84999L1.33333 9.84999L4 9.84999L4.75 9.84999L4.75 9.09999L4.75 1.29999L4.75 0.549988L4 0.549988L1.33333 0.549988L0.583333 0.549988L0.583333 1.29999L0.583333 9.09999Z", fill: "#F74F4F", stroke: "#F4F5F9", "stroke-width": "1.5" })),
                    React.createElement("defs", null,
                        React.createElement("clipPath", { id: "clip0_1993_27673" },
                            React.createElement("rect", { width: "4", height: "13", fill: "white" }))))),
            ' '));
    }
    return resIcon || React.createElement(ReadListIcons.FolderSvg, null);
};
export const defaultFolderDragable = true;
export const defalutFolderAllowDrop = (node) => {
    var _a;
    return ((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) != FLOLDER.STAR;
};
export const defaultOperBtnVisibility = (node) => {
    return folderCanShowOperBtn(node);
};
const FolderTree = forwardRef((props, ref) => {
    const { data, selectedKey, expandedKeys, isOuterDrag = false, editAble = false, isMerge, menu, folderNameRender, unReadRender, operBtnRender, draggable = defaultFolderDragable, allowDrop = defalutFolderAllowDrop, operBtnVisibility = defaultOperBtnVisibility, onExpand, onRightClick, onDragStart, onDragEnd, onUpdateFolder, onDeleteFolder, onSelect, onNodeTitleClick, onAddFolder, onDrop, onOuterDrop, nodeRender, validateOnAdd = defaultValidateFolderChanged, validateOnUpdate = defaultValidateFolderChanged, outerAllowDrop = defaultOuterAllowDrop, dragModel, dropdownClassName, wmReplyShowTip = false, showWmReplyGuide = false, } = props;
    const [localExpandedKeys, setLocalExpandKeys] = useState([]);
    const [menuVisible, setMenuVisible] = useState(false);
    const [menuActiveKey, setMenuActiveKey] = useState(0);
    const [folderDropDownVisiableId, setFolderDropDownVisiableId] = useState();
    const editTreeRef = useRef();
    const [folderTreeIsDrag, setFolderTreeDrag] = useState(false);
    const [draggingFolder, setDraggingFolder] = useState();
    const unReadRenderRef = useStateRef(unReadRender);
    const logicExpandedKeys = useMemo(() => expandedKeys || localExpandedKeys, [expandedKeys, localExpandedKeys]);
    const [key2NodeMap, nodeAllowDropMap] = useMemo(() => {
        const map = {};
        const allowDropMap = {};
        if (data) {
            const allowDropIsFn = typeof allowDrop === 'function';
            const allowDropIsBoolean = typeof allowDrop === 'boolean';
            treeDFS(data, (node) => {
                var _a, _b, _c, _d;
                if ((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) {
                    map[((_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId) + ''] = node;
                    if (allowDropIsFn) {
                        allowDropMap[((_c = node === null || node === void 0 ? void 0 : node.entry) === null || _c === void 0 ? void 0 : _c.mailBoxId) + ''] = allowDrop(node, draggingFolder);
                    }
                    else if (allowDropIsBoolean) {
                        return allowDrop;
                    }
                    else {
                        allowDropMap[((_d = node === null || node === void 0 ? void 0 : node.entry) === null || _d === void 0 ? void 0 : _d.mailBoxId) + ''] = true;
                    }
                }
            });
        }
        return [map, allowDropMap];
    }, [data, allowDrop, draggingFolder]);
    const key2NodeMapRef = useStateRef(key2NodeMap);
    const getNewFolderName = useCallback((tree, node) => {
        var _a, _b;
        const folderModel = node ? key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[node.key + ''] : null;
        let folderName = getIn18Text('WEIMINGMINGWENJIAN');
        const folderNameMap = {};
        const mailBoxId = ((_a = folderModel === null || folderModel === void 0 ? void 0 : folderModel.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) || 0;
        const curGroupFolderList = mailBoxId === 0 ? data : (_b = getTreeNodeById(data, mailBoxId)) === null || _b === void 0 ? void 0 : _b.children;
        let index = 0;
        curGroupFolderList === null || curGroupFolderList === void 0 ? void 0 : curGroupFolderList.forEach(item => {
            const { mailBoxName } = item.entry;
            if (mailBoxName && (mailBoxName === null || mailBoxName === void 0 ? void 0 : mailBoxName.startsWith(folderName))) {
                folderNameMap[mailBoxName] = true;
            }
        });
        while (true) {
            if (!folderNameMap[folderName + (index ? index.toString() : '')]) {
                folderName += index ? index.toString() : '';
                break;
            }
            index += 1;
        }
        return folderName;
    }, [data]);
    const getUpdateFolderName = useCallback((tree, node) => {
        var _a;
        const folderModel = node ? key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[node.key + ''] : null;
        if (folderModel) {
            return ((_a = folderModel === null || folderModel === void 0 ? void 0 : folderModel.entry) === null || _a === void 0 ? void 0 : _a.mailBoxName) || '';
        }
        return '';
    }, [data]);
    const handleMenuAddFolder = useCallback((avtiveKey) => {
        const key = avtiveKey || menuActiveKey;
        const parentNode = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key + ''];
        if (folderAddOperCheck(data, parentNode)) {
            setMenuVisible(false);
            setMenuActiveKey(0);
            setTimeout(() => {
                var _a;
                (_a = editTreeRef === null || editTreeRef === void 0 ? void 0 : editTreeRef.current) === null || _a === void 0 ? void 0 : _a.addNode(key + '');
            }, 0);
        }
    }, [menuActiveKey]);
    const addFolderForEvent = useCreateCallbackForEvent(handleMenuAddFolder);
    const handleMenuAppendFolder = useCallback((avtiveKey) => {
        const key = avtiveKey || menuActiveKey;
        if (validateFolderTreeCount(data)) {
            setTimeout(() => {
                var _a;
                (_a = editTreeRef === null || editTreeRef === void 0 ? void 0 : editTreeRef.current) === null || _a === void 0 ? void 0 : _a.appendNode(key + '');
            }, 10);
        }
    }, [menuActiveKey]);
    const appendFolderForEvent = useCreateCallbackForEvent(handleMenuAppendFolder);
    const handleMenuUpdateFolder = useCallback((avtiveKey) => {
        const key = avtiveKey || menuActiveKey;
        const node = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key + ''];
        if (folderAddOperCheck(data, node)) {
            setMenuVisible(false);
            setMenuActiveKey(0);
            setTimeout(() => {
                var _a;
                (_a = editTreeRef === null || editTreeRef === void 0 ? void 0 : editTreeRef.current) === null || _a === void 0 ? void 0 : _a.updateNode(key + '');
            }, 0);
        }
    }, [menuActiveKey]);
    const updateFolderForEvent = useCreateCallbackForEvent(handleMenuUpdateFolder);
    const handleMenuDeleteFolder = useCallback((avtiveKey) => {
        var _a;
        const key = avtiveKey || menuActiveKey;
        (_a = editTreeRef === null || editTreeRef === void 0 ? void 0 : editTreeRef.current) === null || _a === void 0 ? void 0 : _a.deleteNode(key + '');
        setMenuVisible(false);
        setMenuActiveKey(0);
    }, [menuActiveKey]);
    const deleteFolderForEvent = useCreateCallbackForEvent(handleMenuDeleteFolder);
    const defaultMenuElement = useMemo(() => (React.createElement(Menu, { mode: "horizontal" },
        React.createElement(Menu.Item, { key: "add", onClick: handleMenuAddFolder }, "\u65B0\u5EFA"),
        React.createElement(Menu.Item, { key: "edit", onClick: handleMenuUpdateFolder }, "\u7F16\u8F91"),
        React.createElement(Menu.Item, { key: "delete", onClick: handleMenuDeleteFolder }, "\u5220\u9664"))), [menuActiveKey]);
    const handleTreeRightClick = useCallback((params) => {
        const { node } = params;
        if (node) {
            const key = folderId2Number(node.key);
            setMenuActiveKey(key);
            onRightClick && onRightClick(params);
            setTimeout(() => {
                setMenuVisible(true);
            }, 0);
        }
    }, [onRightClick]);
    const logicMenu = useMemo(() => {
        const lgMenu = menu || defaultMenuElement;
        if (typeof lgMenu === 'function') {
            const node = key2NodeMap[menuActiveKey];
            if (node) {
                return (React.createElement("div", { onClickCapture: () => {
                        setMenuVisible(false);
                        setMenuActiveKey(0);
                        setFolderDropDownVisiableId(null);
                    } }, lgMenu(node)));
            }
            return React.createElement(React.Fragment, null);
        }
        return lgMenu;
    }, [menu, menuActiveKey, key2NodeMap]);
    const handleTitleClick = useCallback((key) => {
        if (onNodeTitleClick) {
            const node = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key + ''];
            onNodeTitleClick(node);
        }
    }, [onNodeTitleClick]);
    const handleTitleClickRef = useCreateCallbackForEvent(handleTitleClick);
    const mergeOperBtnVisibility = useCallback((node) => {
        if (typeof operBtnVisibility === 'function') {
            return editAble && operBtnVisibility(node, defaultOperBtnVisibility);
        }
        return editAble && !!operBtnVisibility;
    }, [operBtnVisibility, editAble]);
    const defaultFolderOperBtn = useCallback((node) => {
        return (React.createElement(Dropdown, { overlayClassName: `u-tree-dropmenu  ${dropdownClassName || ''}`, visible: folderDropDownVisiableId == node.mailBoxId, onVisibleChange: visible => {
                if (visible) {
                    setMenuActiveKey(node.mailBoxId);
                }
                else {
                    setMenuActiveKey(0);
                }
                setFolderDropDownVisiableId(visible ? node.mailBoxId : null);
            }, placement: "bottomRight", overlay: logicMenu, trigger: ['click'] },
            React.createElement("div", { className: "more" }, "...")));
    }, [folderDropDownVisiableId, dropdownClassName]);
    const mergeFolderOperBtn = useCallback((node) => {
        if (operBtnRender && typeof operBtnRender === 'function') {
            const res = operBtnRender(node, defaultFolderOperBtn(node));
            if (res) {
                return res;
            }
        }
        return defaultFolderOperBtn(node);
    }, [operBtnRender, defaultFolderOperBtn]);
    const renderTreeNodeTitle = useCallback((folderNode, innerExpandedKeys) => {
        const node = folderNode === null || folderNode === void 0 ? void 0 : folderNode.entry;
        const showOperBtn = mergeOperBtnVisibility(folderNode);
        const isThread = isMerge == null ? mailConfigStateIsMerge() : isMerge;
        let unRead;
        const expire = !!(node === null || node === void 0 ? void 0 : node.expire);
        if (isThread) {
            if (innerExpandedKeys.includes(node.mailBoxId + '')) {
                if (parseFidFromAllFid(node.mailBoxId) == FLOLDER.DRAFT) {
                    unRead = node.threadMailBoxTotal;
                }
                else if (folderCanShowUnread(node.mailBoxId)) {
                    unRead = '';
                }
                else {
                    unRead = node.threadMailBoxCurrentUnread ? node.threadMailBoxCurrentUnread : '';
                }
            }
            else {
                if ([FLOLDER.DRAFT, FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW].some(id => id == parseFidFromAllFid(node.mailBoxId))) {
                    unRead = node.mailBoxTotal + node.threadMailBoxUnread - node.threadMailBoxCurrentUnread;
                }
                else if (folderCanShowUnread(node.mailBoxId)) {
                    unRead = node.threadMailBoxUnread - node.threadMailBoxCurrentUnread;
                }
                else {
                    unRead = node.threadMailBoxUnread ? node.threadMailBoxUnread : '';
                }
            }
        }
        else {
            if (innerExpandedKeys.includes(node.mailBoxId + '')) {
                if (parseFidFromAllFid(node.mailBoxId) == FLOLDER.DRAFT) {
                    unRead = node.mailBoxTotal;
                }
                else if (folderCanShowUnread(node.mailBoxId)) {
                    unRead = '';
                }
                else {
                    unRead = node.mailBoxCurrentUnread ? node.mailBoxCurrentUnread : '';
                }
            }
            else {
                if ([FLOLDER.DRAFT, FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW].some(id => id == parseFidFromAllFid(node.mailBoxId))) {
                    unRead = node.mailBoxTotal + node.mailBoxUnread - node.mailBoxCurrentUnread;
                }
                else if (folderCanShowUnread(node.mailBoxId)) {
                    unRead = node.mailBoxUnread - node.mailBoxCurrentUnread;
                }
                else {
                    unRead = node.mailBoxUnread ? node.mailBoxUnread : '';
                }
            }
        }
        const folderNameElement = folderNameRender ? folderNameRender(folderNode) : null;
        const unReadRenderElement = unReadRenderRef.current ? unReadRenderRef.current(folderNode, unRead) : null;
        const folderOperBtnElement = mergeFolderOperBtn(folderNode);
        const wmReplyShowTipIn = (node.mailBoxId == FLOLDER.EDM_REPLY || node.mailBoxId == FLOLDER.ALL_EDM_REPLY) && !!unRead;
        return (React.createElement("div", { "data-test-id": `mail-folder-${node.mailBoxName}`, className: `tree-content-warp ${showOperBtn ? 'showOper' : ''} ${expire ? 'all-folder-errtip' : ''}`, onClick: () => handleTitleClickRef(node.mailBoxId) },
            folderNameElement || React.createElement("span", { className: "u-foldername" }, node.mailBoxName),
            unReadRenderElement ||
                (unRead != '' && unRead != null && unRead != 0 ? (React.createElement("span", { className: classnames('u-unread', { 'wm-reply-tip': wmReplyShowTipIn }), "data-test-id": "mail-folder-unread" }, unRead)) : ('')),
            showOperBtn ? (React.createElement("span", { className: "oper-wrap", onClick: e => {
                    e.stopPropagation();
                }, onContextMenu: e => {
                    e.stopPropagation();
                } }, folderOperBtnElement)) : ('')));
    }, [mergeOperBtnVisibility, folderNameRender, logicMenu, mergeFolderOperBtn, wmReplyShowTip]);
    const outerAllowDropProxy = useCallback(node => {
        if (typeof outerAllowDrop == 'function') {
            return outerAllowDrop(node);
        }
        return !!outerAllowDrop;
    }, [outerAllowDrop]);
    const renderTreeNodeTitleWithGuide = useCallback((item, keys) => {
        const wmReplyGuide = false;
        return wmReplyGuide ? (React.createElement(HollowOutGuide, { title: getIn18Text('QIANZAIKEHHFWJJSXL'), guideId: wmReplyGuideKey, intro: getIn18Text('YINGXIAOYOUJQZKHHFZD30'), placement: "right", padding: [6, 0, 6, 35], borderRadius: 0 }, renderTreeNodeTitle(item, keys))) : (renderTreeNodeTitle(item, keys));
    }, [showWmReplyGuide, renderTreeNodeTitle]);
    const renderTreeData = useCallback((data, keys) => data.map(item => {
        var _a, _b, _c, _d;
        let couldDrop = nodeAllowDropMap[(_a = item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId];
        const disabled = isOuterDrag ? !outerAllowDropProxy(item) : false;
        const isMainFolder = item.entry.mailBoxId === FLOLDER.DEFAULT;
        return {
            title: () => renderTreeNodeTitleWithGuide(item, keys),
            key: folderId2String((_b = item.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId),
            icon: getMailFolderIcon(item.entry),
            className: classnames({
                disabled,
                'tree-node-btn-active-hover': folderDropDownVisiableId == ((_c = item.entry) === null || _c === void 0 ? void 0 : _c.mailBoxId),
                'tree-node-active-hover': menuActiveKey == ((_d = item.entry) === null || _d === void 0 ? void 0 : _d.mailBoxId),
                'main-folder': isMainFolder,
                'forbid-drop': folderTreeIsDrag && !couldDrop,
            }),
            disabled,
            nodeData: item,
            children: item.children && item.children.length ? renderTreeData(item.children, keys) : [],
        };
    }), [outerAllowDropProxy, renderTreeNodeTitleWithGuide, folderDropDownVisiableId, menuActiveKey, nodeAllowDropMap, isOuterDrag, folderTreeIsDrag]);
    useImperativeHandle(ref, () => ({
        addFolder: addFolderForEvent,
        appendFolder: appendFolderForEvent,
        updateFolder: updateFolderForEvent,
        deleteFolder: deleteFolderForEvent,
    }));
    const treeRenderData = useMemo(() => renderTreeData(data, logicExpandedKeys), [data, renderTreeData, logicExpandedKeys]);
    const switchDataNode2MailBoxModel = useCallback((node) => {
        var _a;
        const folder = getEmptyMailBoxModel();
        if (node.key) {
            folder.entry.mailBoxId = folderId2Number(node.key);
        }
        folder.entry.mailBoxName = node._name || '';
        folder.entry.pid = node._parentKey ? folderId2Number(node._parentKey) : 0;
        folder.entry.mailBoxParent = node._parentKey ? folderId2Number(node._parentKey) : 0;
        folder._account = data && data.length ? (_a = data[0]) === null || _a === void 0 ? void 0 : _a._account : '';
        return folder;
    }, [getEmptyMailBoxModel]);
    const handleAddFolder = useCallback((e, renderNode, keyList) => {
        if (renderNode) {
            if (onAddFolder) {
                const fidList = folderId2Number(keyList);
                return onAddFolder(switchDataNode2MailBoxModel(renderNode), fidList);
            }
        }
    }, [onAddFolder, switchDataNode2MailBoxModel]);
    const handleUpdateFolder = useCallback((e, renderNode) => {
        if (renderNode) {
            const { key } = renderNode;
            const node = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            if (node) {
                if (onUpdateFolder) {
                    return onUpdateFolder(switchDataNode2MailBoxModel(renderNode));
                }
            }
        }
    }, [onUpdateFolder, switchDataNode2MailBoxModel]);
    const handleDeleteFolder = useCallback((renderNode) => {
        if (renderNode) {
            const { key } = renderNode;
            const node = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            if (node) {
                if (onDeleteFolder) {
                    return onDeleteFolder(node);
                }
            }
        }
    }, [onDeleteFolder]);
    const handleAddFolderValidate = useCallback((tree, renderNode) => {
        if (renderNode) {
            const key = renderNode === null || renderNode === void 0 ? void 0 : renderNode._parentKey;
            const node = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            if (node && validateOnAdd) {
                return validateOnAdd(data, switchDataNode2MailBoxModel(renderNode));
            }
            return true;
        }
    }, [data, validateOnAdd]);
    const handleUpdateFolderValidate = useCallback((tree, renderNode) => {
        if (renderNode) {
            const key = renderNode._parentKey;
            const node = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            if (node && validateOnUpdate) {
                return validateOnUpdate(data, switchDataNode2MailBoxModel(renderNode));
            }
            return true;
        }
    }, [data, validateOnUpdate]);
    const handleOnSelectProxy = useCallback((selectedKeys) => {
        if (selectedKeys && selectedKeys.length) {
            const key = selectedKeys[0];
            console.log('[FolderTree] 选择文件夹 start:', key, Date.now());
            const node = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            if (node && onSelect) {
                onSelect(node);
            }
        }
    }, [onSelect]);
    const handleOnDragStart = useCallback(params => {
        setFolderTreeDrag(true);
        const { event, node } = params;
        const key = node === null || node === void 0 ? void 0 : node.key;
        const folderData = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
        setDraggingFolder(folderData);
        if (onDragStart) {
            onDragStart({
                event,
                node: folderData,
            });
        }
    }, [onDragStart]);
    const handleOnDragEnd = useCallback((params) => {
        setFolderTreeDrag(false);
        setDraggingFolder(null);
        if (onDragEnd) {
            const { event, node } = params;
            event.persist();
            const key = node === null || node === void 0 ? void 0 : node.key;
            const folderData = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            onDragEnd({
                event,
                node: folderData,
            });
        }
    }, [onDragEnd]);
    const handleonExpand = useCallback((expandedKeys, { expanded, node }) => {
        if (onExpand) {
            const key = node === null || node === void 0 ? void 0 : node.key;
            const folderData = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            onExpand(expandedKeys, { expanded, node: folderData });
        }
        else {
            setLocalExpandKeys(expandedKeys);
        }
    }, []);
    const dragAbleProxy = useCallback((node) => {
        if (node) {
            const key = node === null || node === void 0 ? void 0 : node.key;
            const folderModel = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            const draggableIsFn = typeof draggable === 'function';
            const draggableIsBoolean = typeof draggable === 'boolean';
            if (draggableIsFn && folderModel) {
                return draggable(folderModel);
            }
            if (draggableIsBoolean) {
                return draggable;
            }
            return false;
        }
    }, [draggable]);
    const allowDropPorxy = useCallback(({ dropNode }) => {
        if (dropNode) {
            return nodeAllowDropMap[dropNode === null || dropNode === void 0 ? void 0 : dropNode.key];
        }
        return true;
    }, [nodeAllowDropMap]);
    const onDropPorxy = useCallback(({ event, node, dragNode, dragNodesKeys, dropPosition, dropToGap }) => {
        if (onDrop) {
            const key = node === null || node === void 0 ? void 0 : node.key;
            const folderModel = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            const dragKey = dragNode === null || dragNode === void 0 ? void 0 : dragNode.key;
            const dragFolderModel = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[dragKey];
            onDrop({
                event,
                node: folderModel,
                dragNode: dragFolderModel,
                dragNodesKeys,
                dropPosition,
                dropToGap,
            });
        }
    }, [onDrop]);
    const onOuterDropProxy = useCallback(({ event, node }) => {
        const { disabled, key } = node;
        if (!disabled && onOuterDrop) {
            const folderModel = key2NodeMapRef === null || key2NodeMapRef === void 0 ? void 0 : key2NodeMapRef.current[key];
            onOuterDrop({
                event,
                node: folderModel,
            });
        }
    }, [onOuterDrop]);
    const handleOnDragStartRef = useCreateCallbackForEvent(handleOnDragStart);
    const handleOnDragEndRef = useCreateCallbackForEvent(handleOnDragEnd);
    const dragAbleProxyRef = useCreateCallbackForEvent(dragAbleProxy);
    const handleonExpandProxyRef = useCreateCallbackForEvent(handleonExpand);
    const handleAllowDropProxyRef = useCreateCallbackForEvent(allowDropPorxy);
    const handleDropProxyRef = useCreateCallbackForEvent(onDropPorxy);
    const handleOuterDropProxyRef = useCreateCallbackForEvent(onOuterDropProxy);
    const handleOnSelectProxyRef = useCreateCallbackForEvent(handleOnSelectProxy);
    const handleAddFolderRef = useCreateCallbackForEvent(handleAddFolder);
    const handleDeleteFolderRef = useCreateCallbackForEvent(handleDeleteFolder);
    const handleAddFolderValidateRef = useCreateCallbackForEvent(handleAddFolderValidate);
    const handleUpdateFolderRef = useCreateCallbackForEvent(handleUpdateFolder);
    const handleTreeRightClickRef = useCreateCallbackForEvent(handleTreeRightClick);
    const handleUpdateFolderValidateRef = useCreateCallbackForEvent(handleUpdateFolderValidate);
    const getUpdateFolderNameRef = useCreateCallbackForEvent(getUpdateFolderName);
    const getNewFolderNameRef = useCreateCallbackForEvent(getNewFolderName);
    const FolderTreeElement = useMemo(() => (React.createElement(EditTree, { ref: editTreeRef, showIcon: true, blockNode: true, switcherIcon: React.createElement(CaretDownOutlined, null), onExpand: handleonExpandProxyRef, selectedKeys: selectedKey ? [selectedKey + ''] : [], treeData: treeRenderData, expandedKeys: logicExpandedKeys, onSelect: handleOnSelectProxyRef, onRightClick: handleTreeRightClickRef, editAble: false, onAddNode: handleAddFolderRef, getStrTitleOnAdd: getNewFolderNameRef, validateOnAdd: handleAddFolderValidateRef, onUpdateNode: handleUpdateFolderRef, getStrTitleOnUpdate: getUpdateFolderNameRef, validateOnUpdate: handleUpdateFolderValidateRef, onDeleteNode: handleDeleteFolderRef, showLine: folderTreeIsDrag ? { showLeafIcon: false } : false, draggable: dragAbleProxyRef, onDragStart: handleOnDragStartRef, onDragEnd: handleOnDragEndRef, allowDrop: handleAllowDropProxyRef, onDrop: handleDropProxyRef, dragModel: dragModel, isOuterDrag: isOuterDrag, onOuterDrop: handleOuterDropProxyRef, dropdownClassName: dropdownClassName })), [
        treeRenderData,
        logicExpandedKeys,
        folderTreeIsDrag,
        editAble,
        selectedKey,
        isOuterDrag,
        dragModel,
        dropdownClassName,
    ]);
    return (React.createElement("div", { className: `folder-tree-wrap  ${folderTreeIsDrag ? 'folder-tree-draging' : ''} ${isOuterDrag ? 'on-drag' : ''}` }, editAble ? (React.createElement(Dropdown, { overlayClassName: `u-tree-dropmenu  ${dropdownClassName || ''}`, overlayStyle: { width: 'auto' }, trigger: ['contextMenu'], overlay: logicMenu, visible: menuVisible, onVisibleChange: visible => {
            if (!visible) {
                setMenuActiveKey(0);
                setMenuVisible(visible);
            }
        } },
        React.createElement("div", { style: { width: '100%', height: '100%' } }, FolderTreeElement))) : (FolderTreeElement)));
});
export default FolderTree;
